import React, {Component} from "react";
import JobLandingView from "../views/JobLandingView";
import withError from "../withError";
import axios from "axios";
import config from "../config";
import i18n from "../i18n";
import Utility from "../utility";
import {route} from "../routes";
import {StyleguideContext, withRouter, withJobInformationApi, Loading, FormUtility, GelContentContainer, Notices, HandleLoading} from "cw-styleguide-react";

import {withTranslation} from 'react-i18next';

class JobLandingController extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      job: null,
      messages:[],
      dataLoaded: null
    };
  }

  loadJob(jobId) {

    this.props.jobInformationApiGetAboutJobs(this.props.params.jobid, i18n.language, (response) => {

      console.log(response.data);

      // Update the state.
      this.setState({
        data: response.data,
        dataLoaded: true
      });

      // Set language switcher URL.
  //    this.props.styleguide.setLanguageUrl(route('job', {job: response.data.slugTrans}, this.props.i18n.language === 'cy' ? 'en' : 'cy'));

    }, (error) => {
      let errors = FormUtility.processServerErrors(error, i18n);

      this.setState({
        messages: errors.messages,
        dataLoaded:error.response.status
      })
    })


  }

  componentDidMount() {
    this.loadJob(this.props.params.jobid);
  }
  //
  render() {


    return <HandleLoading loading={{dataLoaded:this.state.dataLoaded}} messages={this.state.messages} container={false}><JobLandingView {...this.state}/></HandleLoading>;
  }
}


export default withJobInformationApi(withRouter(withTranslation(['common', 'styleguide'])(JobLandingController)));